import React, { useEffect, useState, VFC } from 'react';
import { Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import Typography from '../components/atoms/Typography';
import { useSettings } from '../contexts/settingsContext';
import useCarrier from '../hooks/useCarrier';
import FreightListItem from '../components/organisms/FreightListItem';
import { useReturnContext } from '../contexts/returnContext';
import Loader from '../components/molecules/Loader';
import { theme } from '../utils/theme';
import Spacing from '../components/atoms/Spacing';

interface Props {
  radius?: string;
}

const SurroundingBorder = styled(Container)<Props>`
  border-radius: ${({ radius }) => radius};
  border: 1px solid #e0e0e0;
  background-color: #fafafa;
`;

const SectionRow = styled(Row)<Props>`
  padding: 32px;
  border-top-left-radius: ${({ radius }) => radius}px;
  border-top-right-radius: ${({ radius }) => radius}px;
`;

const SectionGreyRow = styled.div`
  background-color: #fafafa;
`;

const ReturnFreightPage: VFC = () => {
  const { cornerRadius } = useSettings();
  const { returns } = useReturnContext();
  const { loading: loadingCarriers, getCarriers, carriers } = useCarrier();
  const [selected, onSelect] = useState(undefined);

  useEffect(() => {
    const orderNumbers = Object.values(returns).map((item) => item.orderNumber);
    getCarriers(orderNumbers);
  }, [getCarriers, returns]);

  return (
    <SurroundingBorder radius={cornerRadius}>
      <SectionRow justify="center">
        <Typography variant="h3" translateKey="choose_freight_option" />
      </SectionRow>
      <SectionGreyRow>
        <Spacing spacing={3} />
        {loadingCarriers && <Loader color={theme.colors.grey[80]} />}

        {!loadingCarriers &&
          carriers?.map((item) => (
            <FreightListItem
              key={item.carrier + item.service + item.code}
              carrier={item.carrier}
              onSelect={onSelect}
              selected={selected}
              service={item.service}
              code={item.code}
              logoUrl={item.logoUrl}
            />
          ))}
      </SectionGreyRow>
    </SurroundingBorder>
  );
};

export default ReturnFreightPage;
